module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "twitter_small.ce228039.svg";